module.exports = __webpack_public_path__ + "img/PULSAR.f55c26b1.png";